export const shouldRenderWorldlineDashboard = (): boolean => {
  return (
    window !== undefined &&
    (window.location.hostname === 'worldline.algoan.com' || window.location.hostname === 'worldline.preprod.algoan.com')
  );
};
